import { render, staticRenderFns } from "./ImportPersonalAccount.vue?vue&type=template&id=b795f9ee&scoped=true&"
import script from "./ImportPersonalAccount.vue?vue&type=script&lang=js&"
export * from "./ImportPersonalAccount.vue?vue&type=script&lang=js&"
import style0 from "./ImportPersonalAccount.vue?vue&type=style&index=0&id=b795f9ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b795f9ee",
  null
  
)

export default component.exports